import React from 'react';
import { Input } from '@/components/ui/input';
import { useTranslation } from 'react-i18next';

interface TitleInputProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

const TitleInput: React.FC<TitleInputProps> = ({
  value,
  onChange,
  disabled,
}) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-2">
      <Input
        required
        id="title"
        className="bg-card"
        placeholder={t(
          'agent.new.name_placeholder.translation',
          'Enter agent name'
        )}
        value={value}
        onChange={e => onChange(e.target.value)}
        disabled={disabled}
      />
    </div>
  );
};

export default TitleInput;
